/**
 * 异步加载百度地图
 * @returns {Promise}
 * @constructor
 */
 export function loadBaiDuMap(ak) {
    return new Promise(function (resolve, reject) {
        try {
            // console.log('BMap is defined:', BMapGL === undefined || BMapGL)
            resolve(BMapGL)
        } catch (err) {
            window.init = function () {
                resolve(BMapGL)
            }
            let script = document.createElement('script')
            script.type = 'text/javascript'
            script.src = `https://api.map.baidu.com/api?v=3.0&type=webgl&ak=${ak}&callback=init`
            script.onerror = reject
            document.body.appendChild(script)
        }
    })
}

/**
 * 异步加载百度地图,以及拓展工具
 * @returns {Promise}
 * @constructor
 */
export function loadBaiDuMapAndExtendPlugs(ak, plugs = []) {
    return loadBaiDuMap(ak).then(BMapGL => {
        if (plugs.length) {
            plugs.map(item => {
                let loaded = false
                try {
                    loaded = (BMapGLLib && BMapGLLib[item])
                } catch (err) {
                    loaded = false
                }
                if (!loaded) {
                    if (item == 'DrawingManager') {
                        let script = document.createElement('script')
                        script.type = 'text/javascript'
                        script.src = 'https://mapopen.cdn.bcebos.com/github/BMapGLLib/DrawingManager/src/DrawingManager.min.js'
                        document.body.appendChild(script)
                        let link = document.createElement('link')
                        link.rel = 'stylesheet'
                        link.href = 'https://mapopen.cdn.bcebos.com/github/BMapGLLib/DrawingManager/src/DrawingManager.min.css'
                        document.body.appendChild(link)
                    } else if (item == 'RichMarker') {
                        let script = document.createElement('script')
                        script.type = 'text/javascript'
                        script.src = 'https://mapopen.cdn.bcebos.com/github/BMapGLLib/RichMarker/src/RichMarker.min.js'
                        document.body.appendChild(script)
                    } else if (item == 'InfoBox') {
                        let script = document.createElement('script')
                        script.type = 'text/javascript'
                        script.src = 'https://mapopen.cdn.bcebos.com/github/BMapGLLib/InfoBox/src/InfoBox.min.js'
                        document.body.appendChild(script)
                    }
                }
            })
            return BMapGL
        } else {
            return BMapGL
        }
    })
}
